<template>
  <div class="navBar">
    <slot />
    <ul class="navbarNav">
      <li v-for="link in navLinks" :key="link.name" class="navbarNav__item">
        <router-link :class="cssLinkClass(link.path, link.child)" :to="link.path">
          <i :class="cssIconClass(link.icon)"></i>
          <span :class="`${cssTextClass(link.name)}`">{{ link.name }}</span>
        </router-link>
        <ul v-if="link.child">
          <li v-for="child in link.child" :key="child.name">
            <router-link :class="`navbarNav__childLink ${cssLinkClass(link.path)}`" :to="child.path">
              <i :class="cssIconClass(child.icon)"></i>
              {{ child.name }}
            </router-link>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'NavBar',
  components: {},
  props: {
    isAdmin: Boolean,
    isClientAdmin: Boolean,
    isClient: Boolean,
    isEditor: Boolean,
    isRenderManager: Boolean,
    links: {
      type: Array
    }
  },
  methods: {
    cssTextClass (name) {
      return `navbarNav__text navbarNav--${name.toLowerCase()}`
    },
    cssLinkClass (path, child) {
      return `navbarNav__link${this.hasChild(child)}`
    },
    cssIconClass (icon) {
      return `navbarNav__icon menu-icon fa fa-${icon}`
    },
    hasChild (child) {
      return child ? ' navbarNav__hasChildren' : ''
    }
  },
  mounted () {},
  computed: {
    navLinks: function () {
      const invoiceLink = {
        name: 'Invoices',
        path: '/invoices',
        icon: 'book'
      }
      // const encodingProfileLink = {
      //   name: 'Encoding Profiles',
      //   path: '/encoding-profiles',
      //   icon: 'wrench'
      // }
      const adminLinks = [
        {
          name: 'Users',
          path: '/users',
          icon: 'users'
        },
        {
          name: 'Monitor',
          path: '/monitor',
          icon: 'eye'
        },
        {
          name: 'Render Manager',
          path: '/render-manager',
          icon: 'list'
        }
      ]
      const clientAdmin = [
        {
          name: 'Render Manager',
          path: '/render-manager',
          icon: 'list'
        }
      ]
      let links = [
        {
          name: 'Clients',
          path: '/',
          icon: 'building'
        },
        {
          name: 'Links',
          path: '/links',
          icon: 'link'
        },
        {
          name: 'Tags',
          path: '/tags',
          icon: 'tag'
        },
        {
          name: 'Encoding Profiles',
          path: '/encoding-profiles',
          icon: 'wrench'
        }
      ]
      if (this.isClient) {
        links = links.filter((link) => link.name === 'Clients')
      }
      if (this.isClient) {
        links = links.filter((link) => link.name !== 'Tags')
      }
      if (this.isEditor) {
        links = links.filter((link) => link.name !== 'Encoding Profiles')
      }
      if (this.isAdmin || this.isClientAdmin) {
        links.push(invoiceLink)
        // links.push(encodingProfileLink)
      }
      if (this.isAdmin) {
        adminLinks.forEach(adminLink => {
          links.push(adminLink)
        })
      }
      if (this.isClientAdmin && this.isRenderManager === 1) {
        clientAdmin.forEach(clientAdmin => {
          links.push(clientAdmin)
        })
      }
      return links
    }
  },
  data: () => ({})
}
</script>

<style lang="scss">
    @import "./nav-bar";
</style>



// WEBPACK FOOTER //
// src/components/NavBar/nav-bar.vue